.welcome {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-5);
  text-align: center;
}

.intro {
  margin: 0;
  max-width: 460px;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-muted);
}

.cardGrid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--tuna-spacing-3);
  width: 100%;
  max-width: 560px;
  margin-top: var(--tuna-spacing-2);
}

.card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--tuna-spacing-1);
  padding: var(--tuna-spacing-3);
  text-align: left;
  background: var(--tuna-surface-elevated);
  border: 2px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  cursor: pointer;
  transition:
    background 120ms ease,
    border-color 120ms ease;
}

.card:hover {
  border-color: var(--tuna-palette-primary-main);
}

.card[aria-pressed='true'] {
  border-color: var(--tuna-palette-primary-main);
  background: var(--tuna-palette-action-hover);
}

.cardTitle {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
}

.cardBody {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
}

.cardMeta {
  margin: 0;
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-muted);
}

@media (max-width: 480px) {
  .cardGrid {
    grid-template-columns: 1fr;
  }
}
